module.exports = __webpack_public_path__ + "images/emoji/+1.0f835ee6eaa6708bb927.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/+1.png
// module id = hAVs
// module chunks = 1